// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "template-assets/css/" + chunkId + "." + "a2ac7acb" + ".css";
};